import type { ServicesClientsOrdwayPaymentMethod } from '@customerio/hydra-ui-api';
import type { PaymentCard } from '../types';

/**
 * Map an Ordway payment method into the shared {@link PaymentCard} shape: the account number is
 * sliced to its last four and the payment type is lowercased into a brand, matching how the Ember
 * `cardDetails` getter and `credit-card/card-details` component normalized Ordway card data.
 */
export function ordwayPaymentToPaymentCard(payment: ServicesClientsOrdwayPaymentMethod): PaymentCard {
  return {
    brand: payment.type.toLowerCase(),
    last4: payment.account_number.slice(-4),
    expiry: payment.expiry,
    ownerName: payment.account_holder_name,
  };
}
